// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Le","subtitle":"Me","contentWrap":"Ne","imgWrap":"Oe","heading":"Pe","copy":"Qe"};